<template>
  <transition name="slow-to-anger" >
    <div class="alert alert-danger" style="overflow:hidden;margin: 0.5em;" >
      <h3>Internet connection?</h3>
      <hr>
      <h4>Currently cannot reach the internet.</h4>
    </div>
  </transition>

</template>
<script>
export default {};
</script>

<style scoped>
/* Slow-appearing warning message, quick-vanishing*/

.slow-to-anger-enter,
.slow-to-anger-leave-to {
  opacity: 0;
  max-height: 0;
}

.slow-to-anger-enter-active {
  transition: opacity 2s linear 5s, max-height 5s linear 5s;
}

.slow-to-anger-leave-active {
  transition: opacity 2s, max-height 4s linear;
}

.slow-to-anger-enter-to,
.slow-to-anger-leave {
  opacity: 1;
  max-height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/AppOfflineWarning.vue